import { Popover as PopoverPrimitive } from "@kobalte/core";
import { type JSX, splitProps } from "solid-js";
import { cn } from "@bodega/shared";

import { overlayPortalHost } from "./overlay-portal";

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;

export function PopoverContent(
  props: PopoverPrimitive.PopoverContentProps & { class?: string; children?: JSX.Element },
) {
  const [local, others] = splitProps(props, ["class", "children"]);
  // mount: host data-live-announcer so the Popover is reachable within
  // a modal Dialog (ariaHideOutside) — see overlay-portal.ts (CC-21).
  return (
    <PopoverPrimitive.Portal mount={overlayPortalHost()}>
      <PopoverPrimitive.Content
        class={cn(
          // z-[220]: ABOVE the Dialog (overlay z-[200], content z-[210]) —
          // defensive (CC-21): with z-50 a Popover inside a Dialog would be
          // BELOW the modal and its controls would be unclickable.
          "z-[220] w-72 rounded-md border border-border bg-popover p-4 text-popover-foreground shadow-md outline-none animate-in fade-in zoom-in-95 duration-200",
          local.class,
        )}
        {...others}
      >
        {local.children}
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>
  );
}
